'use client'

import LogoStrip, { type LogoStripItem } from '@/components/marketing/LogoStrip'

// Intrinsic dims must match each file's real content bounds (SVGs cropped to
// content viewBox). displayH is tuned per logo for optical balance: ahrefs is
// bold and fills its box so it runs smaller; Otterly's circle icon makes its
// wordmark read smaller so it runs a touch taller.
const tools: LogoStripItem[] = [
  {
    name: 'Profound',
    src: '/llm-tool-logos/profound.svg',
    width: 916,
    height: 160,
    displayH: 24,
  },
  {
    name: 'Otterly',
    src: '/llm-tool-logos/otterly-ai.png',
    width: 450,
    height: 112,
    displayH: 28,
  },
  {
    name: 'Peec AI',
    src: '/llm-tool-logos/peec-ai.svg',
    width: 498,
    height: 86,
    displayH: 20,
  },
  {
    name: 'Ahrefs Brand Radar',
    src: '/llm-tool-logos/ahrefs-logo.svg',
    width: 885,
    height: 248,
    displayH: 23,
  },
]

export default function MonitoringStackLogos() {
  return (
    <LogoStrip
      items={tools}
      filterFor={theme =>
        theme === 'dark' ? 'grayscale(1) invert(1)' : 'grayscale(1)'
      }
      itemClassName='opacity-60 transition-opacity hover:opacity-100'
    />
  )
}
